// extracted by mini-css-extract-plugin
export default {"container":"Nav_container__A9FAB","list":"Nav_list__Kep7v","icons":"Nav_icons__O8ykz","link":"Nav_link__fadND","icon":"Nav_icon__f1xTn"};